import { render, staticRenderFns } from "./SubdomainChart.vue?vue&type=template&id=4882d2d1&scoped=true&"
import script from "./SubdomainChart.vue?vue&type=script&lang=js&"
export * from "./SubdomainChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882d2d1",
  null
  
)

export default component.exports